import { render, staticRenderFns } from "./buyInvite.vue?vue&type=template&id=04a2de11&scoped=true"
import script from "./buyInvite.vue?vue&type=script&lang=js"
export * from "./buyInvite.vue?vue&type=script&lang=js"
import style0 from "./buyInvite.vue?vue&type=style&index=0&id=04a2de11&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a2de11",
  null
  
)

export default component.exports